module.exports = __webpack_public_path__ + "img/melissa-recibos2.7d856ccb.png";